// Reserved PRACTICE rebus puzzles — the adaptive warm-up pool. Deliberately EASY, self-authored
// RPDs (copyright-clean; snapshot of the /rebus builder's data/practice_rpds.json, whose descriptors
// are folded into getRPD so RebusPicture can draw them). They live OUTSIDE `REBUS_PUZZLES`, so they
// are auto-excluded from the test + free-play pools — no RESERVED_IDS filter needed — and a warm-up
// can never contaminate `firstExposure` or spoil a scored puzzle.
//
// `imageUrl` is empty (these render from the RPD, not a third-party image) and `llmSolveRate` is
// nominal — practice traces carry mode:'practice' + a `practice_*` id, and analysis excludes them.

import { RebusPuzzle } from './rebus.data'

// `explanation` = the player-facing "How it works" decode shown on the warm-up reveal. These are
// deliberately worked-through: the warm-up doubles as a primer, so a first-timer sees the kinds of
// tricks real puzzles use — a count/homophone, spatial position, and one word inside another.
export const REBUS_PRACTICE: RebusPuzzle[] = [
  {
    id: 'practice_forgetit',
    imageUrl: '',
    imageIsGif: false,
    answer: 'Forget it',
    alternatives: [],
    llmSolveRate: 1.0,
    masterDifficulty: 'EASY',
    explanation: 'Four rows of “Get it” = “four get it”. Say it quickly: forget it. Rebuses love a count or a sound-alike like this.',
  },
  {
    id: 'practice_understand',
    imageUrl: '',
    imageIsGif: false,
    answer: 'Try to understand',
    alternatives: [],
    llmSolveRate: 1.0,
    masterDifficulty: 'EASY',
    explanation: 'TRY, then “2” sits under “stand”. Under-stand = understand, and 2 sounds like “to”: try to understand. Where a word sits is part of the clue.',
  },
  {
    id: 'practice_shape',
    imageUrl: '',
    imageIsGif: false,
    answer: 'Get into shape',
    alternatives: [],
    llmSolveRate: 1.0,
    masterDifficulty: 'EASY',
    explanation: '“get” is tucked inside the word SHAPE (SHA-get-PE) — one word placed into another: get into shape.',
  },
]
